import { gql } from '@apollo/client'
import getUserQuery from '../queries/get-me.graphql'

export default gql`
  ${getUserQuery}
`